export default "__VITE_ASSET__ff8e3bc2__"